import ActionType from 'actions/ActionType'

export default (state = true, action) => {
  switch (action.type) {
    case ActionType.Tasks.TOGGLE_GENERAL_PANEL:
      return !Boolean(state)
    case ActionType.Tasks.VALIDATION_FAILURE:
      let expanded = state
      action.errors.forEach(error => {
        if (
          error.dataPath !== '.send_sms.trigger_data.body' &&
          error.dataPath !== '.send_email.trigger_data.default_template_values'
        ) {
          expanded = 'error'
        }
      })
      return expanded
    case ActionType.Tasks.RECEIVE_TASK:
      return true
    default:
      return state
  }
}
